module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/icon03.931ab73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/icon03.png
// module id = W9AC
// module chunks = 0